import React from "react";
import { useSelector } from "react-redux";

import Layout from "../../../components/UI/Layout/Layout";
import BancosList from "./BancosList";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";

export var ScreensBancos = function() {
    var bancos = useSelector(function(state) {
        return state.bancos;
    });
    var isLoading = bancos && bancos.isLoading;

    return (
        <div>
            <LoadingTopBar isActive={isLoading} />
            <Layout>
                <BancosList />
            </Layout>
        </div>
    );
};
